import React from "react";
import { useGetEntityWithParentTaskQuery } from "store/apis/task";
import { Label } from "./CreateServiceForm";
import { useFormikContext } from "formik";
import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import ConditionalToolTip from "components/design/conditionalToolTip";

export const EntitySelectorBasedOnParentTask = ({
  groupId,
}: {
  groupId: string;
}) => {
  const { data = [] } = useGetEntityWithParentTaskQuery(
    { groupId },
    { skip: !groupId }
  );

  const entityOptions = data?.map(
    ({
      entity_name,
      entity_uuid,
      country,
      country_code,
      monthly_bookkeeping_task_status,
    }) => ({
      label: (
        <ConditionalToolTip
          condition={
            !monthly_bookkeeping_task_status &&
            "Entity does not have any active parent task"
          }
        >
          <span>
            <Label
              country={country}
              country_code={country_code}
              name={entity_name}
            />
          </span>
        </ConditionalToolTip>
      ),
      value: entity_uuid,
      isDisabled: !monthly_bookkeeping_task_status,
    })
  );
  const { values: entity } = useFormikContext();
  const selectedEntity = entityOptions.find(({ value }) => entity == value);

  return (
    <Combobox
      label="Entity"
      menuPlacement="auto"
      withForm
      name="entity"
      menuPortalTarget={document.body}
      tooltip
      creatable={false}
      isClearable={false}
      options={entityOptions}
      value={selectedEntity}
      required
    />
  );
};
